// extracted by mini-css-extract-plugin
module.exports = {"desktopHero--blank":"_3pHocLCuRMKYEcsdKr2WDH","heroGradient":"hU92qDOx46YXhyqz0Sg33","heroImageContainer":"_2-rgCaTmDDqt2N-2K28XWk"};